import type { ListingCarCardData } from "@/components/car-listing/listing-car-types";

type SpotlightCar = {
  id: number;
  titleAr: string;
  mainImage?: string | null;
  year?: number | null;
  mileage?: number | null;
  fuelType?: string | null;
  location?: string | null;
  createdAt?: Date | string | null;
  saleType?: string | null;
};

type SpotlightAuction = {
  currentBid?: string | number | null;
  startingPrice?: string | number | null;
};

export function mapSpotlightToListingCards(
  rows: Array<{ car: SpotlightCar; auction?: SpotlightAuction | null }>,
): ListingCarCardData[] {
  return rows.map(({ car, auction }) => ({
    id: car.id,
    titleAr: car.titleAr,
    mainImage: car.mainImage ?? "",
    year: car.year ?? 0,
    mileage: car.mileage ?? 0,
    fuelType: car.fuelType ?? "",
    location: car.location ?? "",
    createdAt: car.createdAt ?? new Date(),
    saleType: "auction",
    sellerName: null,
    auction: auction
      ? {
          currentBid: String(auction.currentBid ?? ""),
          startingPrice: String(auction.startingPrice ?? ""),
        }
      : undefined,
    fixedPrice: undefined,
  }));
}
